import React from 'react';
import { Modal, Pressable, Text, View } from 'react-native';

type Props = {
  visible: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  /** true: onay kırmızı tonlu */
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmModal({
  visible,
  title,
  message,
  confirmLabel,
  cancelLabel = 'Vazgeç',
  destructive = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onCancel}>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="Kapat"
        onPress={onCancel}
        className="flex-1 items-center justify-center bg-black/55 px-5">
        <Pressable
          onPress={e => e.stopPropagation()}
          className="w-full max-w-sm overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-sm dark:border-zinc-700 dark:bg-zinc-900">
          <View className="border-b border-zinc-100 px-5 pb-3 pt-5 dark:border-zinc-800">
            <Text className="text-lg font-bold text-zinc-900 dark:text-zinc-50">{title}</Text>
            {message ? (
              <Text className="mt-2 text-sm leading-5 text-zinc-600 dark:text-zinc-400">{message}</Text>
            ) : null}
          </View>
          <View className="flex-row gap-2 px-4 py-4">
            <Pressable
              accessibilityRole="button"
              onPress={onCancel}
              className="flex-1 items-center rounded-xl border border-zinc-200 bg-zinc-50 py-3.5 active:opacity-80 dark:border-zinc-700 dark:bg-zinc-800">
              <Text className="text-sm font-semibold text-zinc-700 dark:text-zinc-200">{cancelLabel}</Text>
            </Pressable>
            <Pressable
              accessibilityRole="button"
              onPress={onConfirm}
              className={`flex-1 items-center rounded-xl py-3.5 active:opacity-90 ${
                destructive
                  ? 'bg-red-600 dark:bg-red-600'
                  : 'bg-zinc-900 dark:bg-zinc-50'
              }`}>
              <Text
                className={`text-sm font-semibold ${
                  destructive ? 'text-white' : 'text-white dark:text-zinc-950'
                }`}>
                {confirmLabel}
              </Text>
            </Pressable>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
}
